import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import CombilPolicyListItem from './components/combi_policy_list_item'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useNavigate } from 'react-router-dom'
import Modal from '~/components/Modal'
import Button from '~/components/Button'
import LoadingIndicator from '~/components/LoadingIndicator'
import SuccessSvg from '~/components/illustrations/Succes'
import PolicySvg from '~/components/illustrations/Policy'
import { getResourceAuthorization as getResourceAuthorizationSelector, getResourceAuthorizations } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { IResourceAuthorization } from '@verzekeringapp-mono/shared/src/models/resource_authorization'
import useResourceAuthorization from '@verzekeringapp-mono/shared/src/hooks/use_resource_authorization'
import { getUser } from '@verzekeringapp-mono/shared/src/state/selectors/user'
import usePolicies from '@verzekeringapp-mono/shared/src/hooks/use_policies'
import useAgency from '@verzekeringapp-mono/shared/src/hooks/use_agency'

const SelectCombiPolicyScreen: React.FC = () => {
  const { getPolicies } = usePolicies()
  const { getAgency } = useAgency()
  const resourceAuthorizations = useAppSelector(getResourceAuthorizations)
  const resourceAuthorization = useAppSelector(getResourceAuthorizationSelector)
  const [isOpen, setIsOpen] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const navigate = useNavigate()
  const user = useAppSelector(getUser)
  const { changeCurrentResourceAuthorization, deleteResourceAuthorization, getResourceAuthorization } = useResourceAuthorization()

  const onPressDelete = (resourceAuthorization: IResourceAuthorization) => {
    if (!user) {
      alert('Gebruiker niet gevonden. Probeer opnieuw in te loggen.')

      return
    }

    if (window.confirm('Weet je zeker dat je de combipolis wilt verwijderen?')) {
      deleteResourceAuthorization(resourceAuthorization.id)
    }
  }

  useEffect(() => {
    getResourceAuthorization()
  }, [])

  useEffect(() => {
    // Load policies and agency for the current combipolis when switched
    if (resourceAuthorization?.relationInfo) {
      const agencyId = resourceAuthorization.relationInfo.agentNumber

      getPolicies()
      getAgency(agencyId)
    }
  }, [resourceAuthorization?.relationInfo])

  const newCombiPolisButton = (
    <Link
      to='/mijn-profiel/combipolis-toevoegen'
      className='flex flex-row items-center gap-4 rounded-lg border border-action-primary-border bg-action-primary-background p-4 text-action-primary-foreground'
    >
      <div className='mr-2 flex h-[34px] w-[34px] items-center justify-center rounded-full bg-action-primary-foreground'>
        <FontAwesomeIcon
          icon='user'
          size='sm'
          className='text-icon-brand'
        />
      </div>

      <p className='text-action-primary-foreground'>Combipolis toevoegen</p>
    </Link>
  )

  return (
    <ScreenWrapper>
      <div className='flex w-full flex-col items-center rounded border border-border-subtle bg-surface-card p-4 md:p-8'>
        <PolicySvg />

        <p className='title mb-4 text-center'>Welke combipolis?</p>

        <p className='description mb-4 text-center'>
          Geen zorgen! Je kunt altijd weer een andere combipolis selecteren.
        </p>

        <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3  gap-4 p-4 w-full'>
          {
            resourceAuthorization && (
              <CombilPolicyListItem
                resourceAuthorization={resourceAuthorization}
                current={true}
                onPressSelect={() => {
                  setIsOpen(true)
                  setIsLoading(true)
                  changeCurrentResourceAuthorization(resourceAuthorization.relationNumber).then(() => {
                    setIsLoading(false)
                  })
                }}
                onPressDelete={onPressDelete}
              />
            )
          }

          {resourceAuthorizations.map(resourceAuth => (
            <CombilPolicyListItem
              key={resourceAuth.id}
              resourceAuthorization={resourceAuth}
              current={false}
              onPressSelect={resourceAuthorization => {
                setIsOpen(true)
                setIsLoading(true)
                changeCurrentResourceAuthorization(resourceAuthorization.relationNumber).then(() => {
                  setIsLoading(false)
                })
              }}
              onPressDelete={onPressDelete}
            />
          ))}

          {newCombiPolisButton}
        </div>

        {isOpen && (
          <Modal onClose={() => setIsOpen(false)}>
            <div className='flex h-full flex-col items-center justify-center gap-4 p-8 md:h-2/4'>
              {isLoading
                ? (
                  <LoadingIndicator />
                )
                : (
                  <>
                    <SuccessSvg />

                    <p className='title text-center'>Succesvol ingesteld!</p>

                    <p className='text-center'>
                    Je bent succesvol gewisseld van combipolis
                    </p>

                    <Button
                      className={'primary-btn w-full mt-8 mb-3'}
                      onClick={() => navigate('/')}
                    >
                    Doorgaan
                    </Button>
                  </>
                )}
            </div>
          </Modal>
        )}
      </div>
    </ScreenWrapper>
  )
}

export default SelectCombiPolicyScreen
